import { createSlice } from '@reduxjs/toolkit'
import { ResponseDataBody } from 'src/types/websocket'

const initialState: ResponseDataBody.WifiList = {
  WifiInfos: null,
}

const wifiSlice = createSlice({
  name: 'wifiInfo',
  initialState,
  reducers: {
    setWifiInfo(state, action) {
      state.WifiInfos = action.payload.WifiInfos?.sort(
        (a: { Strength: number }, b: { Strength: number }) => b.Strength - a.Strength,
      )
    },
  },
})

export const { setWifiInfo } = wifiSlice.actions

export default wifiSlice.reducer
